<template>
<div :style="{
  marginLeft: marginLeft + 'px',
  marginBottom: marginBottom + 'px',
  marginTop: marginTop + 'px',
  width: styleWidth
}">
  <p class="static-tips" v-html="getCont()"></p>
</div>
</template>
<script>
import i18n from '../../language/index'

export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    type: {
       type: String,
      default: ''
    },
    typeName: {
       type: String,
      default: ''
    },
    marginLeft: {
       type: Number,
      default: 0
    },
    marginTop: {
       type: Number,
      default: -14
    },
    marginBottom: {
       type: Number,
      default: 22
    },
    styleWidth: {
       type: String,
       default: ''
    },
  },
  data() {
    return {
      static:i18n.t('components_statictips_index_2471'),
      order:i18n.t('components_statictips_index_2472'),
      img:i18n.t('components_statictips_index_2473'),
      showStatus:i18n.t('components_statictips_index_2474'),
      product: {
        'name' : i18n.t('components_statictips_index_2475'),
        'type_name' : i18n.t('components_statictips_index_2476'),
        'tag_list' : i18n.t('components_statictips_index_2477'),
        'order': i18n.t('components_statictips_index_2472'),
        'summary' : i18n.t('components_statictips_index_2478'),
        'img': i18n.t('components_statictips_index_2479'),
        'video': i18n.t('components_statictips_index_2480'),
        'up_time': i18n.t('components_statictips_index_2481'),
      },
      article: {
        'title':i18n.t('components_statictips_index_2482'),
        'type_name':i18n.t('components_statictips_index_2483'),
        'tag_list':i18n.t('components_statictips_index_2484'),
        'order':i18n.t('components_statictips_index_2472'),
        'author':i18n.t('components_statictips_index_2485'),
        'source':i18n.t('components_statictips_index_2486'),
        'summary':i18n.t('components_statictips_index_2487'),
        'up_time':i18n.t('components_statictips_index_2488'),
      },
      cate: {
        'summary': i18n.t('components_statictips_index_2489')
      },
      nav: {
        'title' : i18n.t('components_statictips_index_2490'),
        'img' : i18n.t('components_statictips_index_2491')
      },
      replace: {
        'type_name' : i18n.t('components_statictips_index_2483')
      },
      album:{
        'title': i18n.t('components_statictips_index_2482'),
        'type_name': i18n.t('components_statictips_index_2492'),
        'img': i18n.t('components_statictips_index_2493'),
      }

    };
  },
  watch: {
  },
  components: {
  },
  computed: {
  },
  created() {
  },
  methods: {
    getCont(){
      if(this.typeName){
        let arr = this.typeName.split('.')
        if(arr.length == 2){
          return this[arr[0]][arr[1]];
        }else{
          return this[arr[0]];
        }
      }
      return this.content
    }
  },
  watch: {
  },
};
</script>

<style lang="scss" scoped>
.static-tips {
    font-size: 12px;
    line-height: 20px;
    color: #333;
    opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/staticTips/index.vue